import { render } from "./FashionsList.vue?vue&type=template&id=3b9c8fd3"
import script from "./FashionsList.vue?vue&type=script&lang=js"
export * from "./FashionsList.vue?vue&type=script&lang=js"

import "./FashionsList.vue?vue&type=style&index=0&id=3b9c8fd3&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__